import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAnimating: false,
  startPosition: { x: 0, y: 0 },
  endPosition: { x: 0, y: 0 },
  imageSrc: null,
};

const animationSlice = createSlice({
  name: 'animation',
  initialState,
  reducers: {
    setProfileLinkPosition(state, action) {
      state.endPosition = action.payload;
    },
    startAnimation(state, action) {
      state.isAnimating = true;
      state.startPosition = action.payload.startPosition;
      state.imageSrc = action.payload.imageSrc;
    },
    endAnimation(state) {
      state.isAnimating = false;
      state.imageSrc = null;
    },
  },
});

export const { setProfileLinkPosition, startAnimation, endAnimation } = animationSlice.actions;
export default animationSlice.reducer;
